var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cog-dialog", attrs: { tabindex: "0" } },
    [
      _c("i-ex"),
      _vm._v(" "),
      _c(
        "el-dialog",
        _vm._g(
          {
            attrs: {
              title: _vm.title,
              visible: _vm.visible,
              "close-on-click-modal": _vm.closeModal
            },
            on: { opened: _vm.handleOpened, closed: _vm.handleClosed },
            nativeOn: {
              mousedown: function($event) {
                return _vm.startDrag($event)
              },
              mouseup: function($event) {
                return _vm.stopDrag($event)
              }
            }
          },
          _vm.$listeners
        ),
        [_vm._t("title"), _vm._v(" "), _vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }